<script setup>
    const { $bus } = useNuxtApp();
    
    const props = defineProps({
        posts: Array,
    });

    const open = defineModel('open');
    const localOpen = ref(false)
    const tags = defineModel('tags', { default: []});

    const applyTags = () => { open.value = false; }
    const clearTags = () => { tags.value = new Set([]); }

    const drawerStyles = {
        overlay: 'bg-[var(--purple)]/80 backdrop-blur-xs',
    };

    watch(open, (val) => {
        if (val) $bus.emit('drawer-open');
        else $bus.emit('drawer-close');
        const hs = document.getElementById('hubspot-messages-iframe-container');
        if (hs) hs.style.display = val ? 'none' : '';
    })

</script>

<template>
    <UDrawer v-model:open="open" id="blog-tags-drawer" direction="right" :dismissable="true" :ui="drawerStyles" class='blog-tags-drawer filter-overlay font-hubspot-sans' title="Filter" :handle="false">
        <template #header>
            <div class="header flex justify-between items-center">
                <h3 class="font-hubspot-serif text-[calc(30/var(--base-fs)*1rem)] font-normal leading-[1.3] tracking-normal text-(--magenta)">Filter by Tag <span class="count text-[calc(30/var(--base-fs)*1rem)] text-(--dark-pink) ml-4" v-if="tags.size">{{ tags.size }}</span></h3>
                <UButton class="closebutton rounded-full!" color="primary" variant="outline" icon="i-lucide-x" @click="open = false" />
            </div>
        </template>
        <template #body>
            <div class="inner">
                <FragmentsFiltersPostTags v-model:tags="tags" />
            </div>
        </template>
        <template #footer>
            <div class="drawer-footer">
                <div class="buttons flex justify-start self-center gap-[1.625rem] flex-nowrap">
                    <button tabindex="0"
                        class="cta flex items-center rounded-[50px] py-2.5 px-5 max-w-fit font-hubspot-serif text-[calc(17/var(--base-fs)*1rem)] leading-[1.4] tracking-[0.34px] transition-all duration-250 whitespace-nowrap bg-white text-(--magenta) border border-(--magenta) hover:bg-(--magenta) hover:text-white"
                        @click="applyTags"
                        :aria-label="`Close this panel and see ${posts.length} results`">See Results&nbsp;<span v-if="posts?.length">({{ posts.length }})</span></button>
                    <button tabindex="0"
                        class="bg-transparent text-(--dark-pink) decoration-dotted underline underline-offset-3 decoration-1 p-3.75 font-hubspot-serif text-[calc(17/var(--base-fs)*1rem)] leading-[1.4] tracking-[0.34px] transition-all duration-250 hover:no-underline"
                        @click="clearTags" aria-label="Unselect all selected tags">Clear All</button>
                </div>
            </div>
        </template>
    </UDrawer>
</template>

<style>
/* close button hover — matches session drawer */
</style>